import type { Meta, StoryObj } from "@storybook/react";

import type { RecentWeightSummaryProps } from "@/ui/components/vitals/overview/RecentWeightSummary";
import RecentWeightSummary from "@/ui/components/vitals/overview/RecentWeightSummary";

const StoryMeta: Meta<RecentWeightSummaryProps> = {
  title: "Components/Vitals/Weight/Recent Weight Summary",
  component: RecentWeightSummary,
  argTypes: {
    isWeeklyWeightChange: { control: "boolean" },
    loggedBy: { control: "text" },
    unit: { control: "text" },
    value: { control: "number" },
    weightChange: { control: "number" },
  },
  args: {
    isWeeklyWeightChange: true,
    loggedBy: "Logged on Sun, April 23 by Charlotte",
    unit: "lbs",
    value: 123.45,
    weightChange: -1.2,
  },
};

type Story = StoryObj<RecentWeightSummaryProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
